<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>upp-image</h2>
            <p class="demo-description">Product photo display &amp; editing. In <strong>upload</strong> mode it opens the file picker directly; in <strong>config</strong> mode it opens avatar/upload/search options plus crop on the current image when available.</p>

            <!-- Controls -->
            <div class="demo-controls">
                <ion-button size="small" (click)="toggleReadonly()">
                    <ion-icon name="lock-closed-outline" slot="start" *ngIf="isReadonly"></ion-icon>
                    <ion-icon name="lock-open-outline" slot="start" *ngIf="!isReadonly"></ion-icon>
                    Editable: {{ !isReadonly }}
                </ion-button>

                <div class="demo-control-group">
                    <label class="demo-label">Mode</label>
                    <div class="demo-mode-buttons">
                        <ion-button size="small" [fill]="selectedMode === 'upload' ? 'solid' : 'outline'" (click)="setMode('upload')">upload</ion-button>
                        <ion-button size="small" [fill]="selectedMode === 'config' ? 'solid' : 'outline'" (click)="setMode('config')">config</ion-button>
                    </div>
                </div>

                <div class="demo-control-group">
                    <label class="demo-label">Search seed</label>
                    <input type="text" [(ngModel)]="searchText" class="demo-text-input" maxlength="16">
                </div>

                <div class="demo-control-group">
                    <label class="demo-label">Crop width</label>
                    <input type="number" [(ngModel)]="crwidth" class="demo-number-input">
                </div>

                <div class="demo-control-group">
                    <label class="demo-label">Crop height</label>
                    <input type="number" [(ngModel)]="crheight" class="demo-number-input">
                </div>
            </div>

            <!-- Updated banner -->
            <div class="demo-toast" *ngIf="imageUpdated">
                <ion-icon name="checkmark-circle-outline"></ion-icon>
                Image updated!
            </div>

            <!-- Single image: toggles readonly/editable -->
            <div class="demo-section">
                <h3>Product Photo ({{ isReadonly ? 'readonly' : 'editable' }}, mode: {{ selectedMode }})</h3>
                <p class="demo-label">
                    {{ isReadonly ? 'Click the lock to enable editing.' : (selectedMode === 'config'
                        ? 'Use settings for avatar, upload, search, or crop the current image.'
                        : 'Use camera icon to upload a local image directly.') }}
                </p>
                <div class="image-frame">
                    <upp-image #imageRef
                        [src]="imageSrc"
                        [readonly]="isReadonly"
                        [mode]="selectedMode"
                        [search]="searchText"
                        [crwidth]="crwidth"
                        [crheight]="crheight"
                        (Changed)="onImageChanged(imageRef)">
                    </upp-image>
                </div>
            </div>
        </div>
    </upp-scrollable>
</div>
